// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3ylQ0","alertIcon":"ConfirmModal_alertIcon__1VDP-"};